// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
  * {
    border: none;
    box-shadow: none;
  }
}

.styles__header___pskri {
  background: white;
  border-radius: 3px;
  margin: 0 0 20px;
  padding: 20px;
  width: 100%;
}

@media print {

.styles__header___pskri {
    position: fixed;
    top: 0;
}
  }

.styles__section___NvawL {
}

@media print {

.styles__section___NvawL {
    padding: 0;
}
  }

.styles__contentContainer___mztTv {
  display: flex;
  flex-direction: column;
}

@media print {

.styles__contentContainer___mztTv {
    display: block;
    margin: 0;
    padding: 0;
}
  }

.styles__period___oiwQY {
  margin: 10px 0 2px;
}

.styles__contactInfo___smvJ4 {
  clear: both;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
  display: none;
  float: right;
  font-size: 0.75em;
}

@media print {

.styles__contactInfo___smvJ4 {
    display: block;
}
  }

.styles__logo___ofeX6 {
  height: 57px;
}

.styles__invisible____8wRM {
  visibility: hidden;
  height: 0;
}

.styles__visible___f25Pk {
  visibility: visible;
}

.styles__label___AkgXV {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  font-size: 10px;
}

.styles__balanceCell___gkjQT,
.styles__creditCell___QRYH9,
.styles__dateCell___d6vwn,
.styles__debitCell___xrF14,
.styles__leftMono___S6Qsm,
.styles__mono___Sksz0 {
  font-family: MaisonMono, monospace;
}

.styles__table___MYGkc {
  width: 100%;
}

.styles__table___MYGkc td,
  .styles__table___MYGkc th {
    font-weight: normal;
    padding-right: 20px;
  }

.styles__table___MYGkc th {
    font-weight: bold;
  }

.styles__table___MYGkc > tbody tr:last-child td:first-child {
      border-bottom-left-radius: 3px;
    }

.styles__table___MYGkc > tbody tr:last-child td:last-child {
      border-bottom-right-radius: 3px;
    }

.styles__nonRepeatingFooter___qoz1g {
  display: table-row-group;
}

@media print {

.styles__printBreak___bR9lQ {
    page-break-after: always;
}
  }

.styles__dateCell___d6vwn,
.styles__dateHeader___TZzRL,
.styles__dateHeaderTfoot___pavFD,
.styles__descriptionHeader___vXk0J,
.styles__descriptionHeaderTfoot___HcXcO,
.styles__left___iBf_M,
.styles__leftMono___S6Qsm {
  text-align: left;
}

.styles__balanceCell___gkjQT,
.styles__balanceHeader___hqR0O,
.styles__balanceHeaderTfoot___RIv8C,
.styles__creditCell___QRYH9,
.styles__creditHeader___hZa4z,
.styles__debitCell___xrF14,
.styles__debitHeader___g6TVj,
.styles__debitHeaderTfoot___nA_xj {
  text-align: right;
}

.styles__reportHeader___KYHHE {
}

.styles__secondaryHeader___uUmXl {
  padding-top: 0;
  padding-bottom: 10px;
}

.styles__spacer___FxXQN {
  height: 20px;
}

.styles__balanceHeader___hqR0O,
.styles__creditHeader___hZa4z,
.styles__dateHeader___TZzRL,
.styles__debitHeader___g6TVj,
.styles__descriptionHeader___vXk0J {
  background-color: white;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  font-size: 12px;
  margin-bottom: 50px;
  padding-bottom: 10px;
  padding-top: 10px;
}

.styles__balanceHeaderTfoot___RIv8C,
.styles__creditHeaderTfoot___d_56a,
.styles__dateHeaderTfoot___pavFD,
.styles__debitHeaderTfoot___nA_xj,
.styles__descriptionHeaderTfoot___HcXcO {
  background-color: white;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  font-size: 12px;
  height: 50px;
  padding-bottom: 10px;
  padding-top: 10px;
  vertical-align: bottom;
}

.styles__dateHeader___TZzRL,
.styles__dateHeaderTfoot___pavFD {
  border-top-left-radius: 3px;
  padding-left: 20px;
}

.styles__balanceHeader___hqR0O,
.styles__balanceHeaderTfoot___RIv8C {
  border-top-right-radius: 3px;
}

.styles__balanceCell___gkjQT,
.styles__dateCell___d6vwn,
.styles__debitCell___xrF14,
.styles__descriptionCell___EWh1U,
.styles__creditCell___QRYH9 {
  background-color: white;
  border-top: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]};
  padding-bottom: 10px;
  padding-top: 10px;
}

.styles__dateCell___d6vwn {
  padding-left: 20px;
}

.styles__address___j6DCh {
  display: block;
  margin-top: 5px;
  margin-bottom: 70px;
  width: auto;
  clear: both;
}

.styles__address___j6DCh .styles__logo___ofeX6 {
    height: 30px;
    padding: 0;
    margin: 0;
  }

.styles__address___j6DCh .styles__toAddress___cMGyd {
    font-weight: bold;
    margin-top: 85px;
  }

.styles__tableTitle___GsLP7 {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  margin-top: 2px;
  font-size: 21px;
}

.styles__boldRow___qW_hq td {
  font-weight: bold;
}

.styles__spacerRow___YmRTa {
  height: 40px;
}
`, "",{"version":3,"sources":["webpack://./universal/components/AccountStatement/styles.css"],"names":[],"mappings":"AAIA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,WAAW;AAMb;;AAJE;;AAPF;IAQI,eAAe;IACf,MAAM;AAEV;EADE;;AAGF;AAMA;;AAHE;;AAHF;IAII,UAAU;AAEd;EADE;;AAGF;EAEE,aAAa;EACb,sBAAsB;AAMxB;;AALE;;AAJF;IAKI,cAAc;IACd,SAAS;IACT,UAAU;AAEd;EADE;;AAGF;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mDAAa;EACb,aAAa;EACb,YAAY;EACZ,iBAAiB;AAKnB;;AAHE;;AAPF;IAQI,cAAc;AAElB;EADE;;AAGF;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mDAAgB;EAChB,eAAe;AACjB;;AAEA;;;;;;EAME,kCAAkC;AACpC;;AAEA;EACE,WAAW;AAqBb;;AAnBE;;IAEE,mBAAmB;IACnB,mBAAmB;EACrB;;AAEA;IACE,iBAAiB;EACnB;;AAGE;MACE,8BAA8B;IAChC;;AAEA;MACE,+BAA+B;IACjC;;AAIJ;EACE,wBAAwB;AAC1B;;AAGE;;AADF;IAEI,wBAAwB;AAE5B;EADE;;AAGF;;;;;;;EAOE,gBAAgB;AAClB;;AAEA;;;;;;;;EAQE,iBAAiB;AACnB;;AAEA;AAEA;;AAEA;EAEE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;EAKE,uBAAuB;EACvB,mDAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;;;;EAKE,uBAAuB;EACvB,mDAAgB;EAChB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;EAEE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;;;;EAKE,uBAAuB;EACvB,kEAAiC;EACjC,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,WAAW;AAYb;;AAVE;IACE,YAAY;IACZ,UAAU;IACV,SAAS;EACX;;AAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;AAGF;EACE,mDAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd","sourcesContent":["@value helpers: 'styles/helpers.css';\n@value colors: 'styles/colors.css';\n@value gtBlue, gtBlueLight, gtYellowLight, textLight from colors;\n\n@media print {\n  * {\n    border: none;\n    box-shadow: none;\n  }\n}\n\n.header {\n  background: white;\n  border-radius: 3px;\n  margin: 0 0 20px;\n  padding: 20px;\n  width: 100%;\n\n  @media print {\n    position: fixed;\n    top: 0;\n  }\n}\n\n.section {\n  composes: section from helpers;\n\n  @media print {\n    padding: 0;\n  }\n}\n\n.contentContainer {\n  composes: content-container from helpers;\n  display: flex;\n  flex-direction: column;\n  @media print {\n    display: block;\n    margin: 0;\n    padding: 0;\n  }\n}\n\n.period {\n  margin: 10px 0 2px;\n}\n\n.contactInfo {\n  clear: both;\n  color: gtBlue;\n  display: none;\n  float: right;\n  font-size: 0.75em;\n\n  @media print {\n    display: block;\n  }\n}\n\n.logo {\n  height: 57px;\n}\n\n.invisible {\n  visibility: hidden;\n  height: 0;\n}\n\n.visible {\n  visibility: visible;\n}\n\n.label {\n  color: textLight;\n  font-size: 10px;\n}\n\n.balanceCell,\n.creditCell,\n.dateCell,\n.debitCell,\n.leftMono,\n.mono {\n  font-family: MaisonMono, monospace;\n}\n\n.table {\n  width: 100%;\n\n  td,\n  th {\n    font-weight: normal;\n    padding-right: 20px;\n  }\n\n  th {\n    font-weight: bold;\n  }\n\n  & > tbody tr:last-child {\n    td:first-child {\n      border-bottom-left-radius: 3px;\n    }\n\n    td:last-child {\n      border-bottom-right-radius: 3px;\n    }\n  }\n}\n\n.nonRepeatingFooter {\n  display: table-row-group;\n}\n\n.printBreak {\n  @media print {\n    page-break-after: always;\n  }\n}\n\n.dateCell,\n.dateHeader,\n.dateHeaderTfoot,\n.descriptionHeader,\n.descriptionHeaderTfoot,\n.left,\n.leftMono {\n  text-align: left;\n}\n\n.balanceCell,\n.balanceHeader,\n.balanceHeaderTfoot,\n.creditCell,\n.creditHeader,\n.debitCell,\n.debitHeader,\n.debitHeaderTfoot {\n  text-align: right;\n}\n\n.reportHeader {\n  composes: section from helpers;\n}\n\n.secondaryHeader {\n  composes: section from helpers;\n  padding-top: 0;\n  padding-bottom: 10px;\n}\n\n.spacer {\n  height: 20px;\n}\n\n.balanceHeader,\n.creditHeader,\n.dateHeader,\n.debitHeader,\n.descriptionHeader {\n  background-color: white;\n  color: textLight;\n  font-size: 12px;\n  margin-bottom: 50px;\n  padding-bottom: 10px;\n  padding-top: 10px;\n}\n\n.balanceHeaderTfoot,\n.creditHeaderTfoot,\n.dateHeaderTfoot,\n.debitHeaderTfoot,\n.descriptionHeaderTfoot {\n  background-color: white;\n  color: textLight;\n  font-size: 12px;\n  height: 50px;\n  padding-bottom: 10px;\n  padding-top: 10px;\n  vertical-align: bottom;\n}\n\n.dateHeader,\n.dateHeaderTfoot {\n  border-top-left-radius: 3px;\n  padding-left: 20px;\n}\n\n.balanceHeader,\n.balanceHeaderTfoot {\n  border-top-right-radius: 3px;\n}\n\n.balanceCell,\n.dateCell,\n.debitCell,\n.descriptionCell,\n.creditCell {\n  background-color: white;\n  border-top: 1px solid gtBlueLight;\n  padding-bottom: 10px;\n  padding-top: 10px;\n}\n\n.dateCell {\n  padding-left: 20px;\n}\n\n.address {\n  display: block;\n  margin-top: 5px;\n  margin-bottom: 70px;\n  width: auto;\n  clear: both;\n\n  .logo {\n    height: 30px;\n    padding: 0;\n    margin: 0;\n  }\n\n  .toAddress {\n    font-weight: bold;\n    margin-top: 85px;\n  }\n}\n\n.tableTitle {\n  color: textLight;\n  margin-top: 2px;\n  font-size: 21px;\n}\n\n.boldRow td {\n  font-weight: bold;\n}\n\n.spacerRow {\n  height: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `'styles/helpers.css'`,
	"colors": `'styles/colors.css'`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"gtBlueLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]}`,
	"gtYellowLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowLight"]}`,
	"textLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]}`,
	"header": `styles__header___pskri`,
	"section": `styles__section___NvawL ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"contentContainer": `styles__contentContainer___mztTv ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]}`,
	"period": `styles__period___oiwQY`,
	"contactInfo": `styles__contactInfo___smvJ4`,
	"logo": `styles__logo___ofeX6`,
	"invisible": `styles__invisible____8wRM`,
	"visible": `styles__visible___f25Pk`,
	"label": `styles__label___AkgXV`,
	"balanceCell": `styles__balanceCell___gkjQT`,
	"creditCell": `styles__creditCell___QRYH9`,
	"dateCell": `styles__dateCell___d6vwn`,
	"debitCell": `styles__debitCell___xrF14`,
	"leftMono": `styles__leftMono___S6Qsm`,
	"mono": `styles__mono___Sksz0`,
	"table": `styles__table___MYGkc`,
	"nonRepeatingFooter": `styles__nonRepeatingFooter___qoz1g`,
	"printBreak": `styles__printBreak___bR9lQ`,
	"dateHeader": `styles__dateHeader___TZzRL`,
	"dateHeaderTfoot": `styles__dateHeaderTfoot___pavFD`,
	"descriptionHeader": `styles__descriptionHeader___vXk0J`,
	"descriptionHeaderTfoot": `styles__descriptionHeaderTfoot___HcXcO`,
	"left": `styles__left___iBf_M`,
	"balanceHeader": `styles__balanceHeader___hqR0O`,
	"balanceHeaderTfoot": `styles__balanceHeaderTfoot___RIv8C`,
	"creditHeader": `styles__creditHeader___hZa4z`,
	"debitHeader": `styles__debitHeader___g6TVj`,
	"debitHeaderTfoot": `styles__debitHeaderTfoot___nA_xj`,
	"reportHeader": `styles__reportHeader___KYHHE ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"secondaryHeader": `styles__secondaryHeader___uUmXl ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"spacer": `styles__spacer___FxXQN`,
	"creditHeaderTfoot": `styles__creditHeaderTfoot___d_56a`,
	"descriptionCell": `styles__descriptionCell___EWh1U`,
	"address": `styles__address___j6DCh`,
	"toAddress": `styles__toAddress___cMGyd`,
	"tableTitle": `styles__tableTitle___GsLP7`,
	"boldRow": `styles__boldRow___qW_hq`,
	"spacerRow": `styles__spacerRow___YmRTa`
};
export default ___CSS_LOADER_EXPORT___;
